<template>
	<div class="equipment">
		<div class="title">
			<img src="../../../assets/img/logo.png" alt="">
			<span>设备信息展示</span>
		</div>
		<div class="equipmentbox">
			<div class="equipmentbox_title">
				<div>设备名称</div>
				<div>设备编号</div>
				<div>设备时间</div>
				<div>运行状态</div>
			</div>
			<div class="equipmentbox_table" @click="show($event)">
				<vue-seamless-scroll :data="tableData" :class-option="optionLeft" class="seamless-warp" >
				<ul v-for="item,index in tableData" :key="index">
					<li>{{item.date}}</li>
					<li>{{item.name}}</li>
					<li>{{item.address}}</li>
					<li clickflag='true'>{{item.addstate}}</li>
				</ul>
				</vue-seamless-scroll>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
	  	return{
			 tableData: [
			          {
			            date: '设备1',
			            name: 'AST100',
			            address: '2021.02.12',
						addstate:'正常'
			          },
			          {
			            date: '设备2',
			            name: 'AST101',
			            address: '2021.02.12',
			          	addstate:'正常'
			          },
			          {
			            date: '设备3',
			            name: 'AST102',
			            address: '2021.02.12',
			          	addstate:'正常'
			          },
			          {
			            date: '设备4',
			            name: 'AST103',
			            address: '2021.02.12',
			          	addstate:'正常'
			          },
			          {
			            date: '设备5',
			            name: 'AST104',
			            address: '2021.02.12',
			          	addstate:'正常'
			          },
					  {
					    date: '设备6',
					    name: 'AST105',
					    address: '2021.02.12',
					  	addstate:'正常'
					  },
					  {
					    date: '设备7',
					    name: 'AST100',
					    address: '2021.02.12',
					  	addstate:'正常'
					  },
					  {
					    date: '设备8',
					    name: 'AST100',
					    address: '2021.02.12',
					  	addstate:'正常'
					  }
			        ],
		}
	  },
	  computed: {
		  optionLeft () {
			  return {
				      step: 1, // 数值越大速度滚动越快
			          limitMoveNum: this.tableData.length, // 开始无缝滚动的数据量 this.dataList.length
			          hoverStop: true, // 是否开启鼠标悬停stop
			          direction: 1, // 0向下 1向上 2向左 3向右
			          openWatch: true, // 开启数据实时监控刷新dom
			          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
			          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
			          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
				  }
		  }
	  },
	  methods: {
		  show(e){
			  if(e){
				  // console.log(e.target,e.target.getAttribute('clickflag'))
				  if(e.target.getAttribute('clickflag')=='true'){
					  console.log(e.target,'一二三')
				  }
			  }
			  
		  }
	  },
	  mounted() {
	  }
	};
</script>

<style>
	li{
		list-style: none;
	}
	.seamless-warp{
		 height: 200%;
		 width: 100%;
		overflow: hidden;
	}
	.equipment{
		width: 100%;
		height: 37%;
	}
	.equipmentbox{
		width: 100%;
		height: calc(100% - 4vh);
		box-sizing: border-box;
		padding: 2vh 0 1vh;
		position: relative;
	}
	.equipmentbox_title{
		width: 100%;
		position: absolute;
		height:4vh;
		display: flex;
		color: #FFFFFF;
		background: url(../../../assets/img/equipmentbg.png) no-repeat;
		background-size: 100% 100%;
	}
	.equipmentbox_title>div{
		text-align: center;
		width: 25%;
		display: flex;
		font-size: .8vw;
		align-items: center;
		justify-content: center;
		font-weight: 400;
	}
	.equipmentbox_table{
		margin-top: 4vh;
		overflow: auto;
		width: 100%;
		height: calc(100% - 4vh);
	}
	.equipmentbox_table::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.equipmentbox_table ul{
		width: 100%;
		height: 15%;
		/* padding: 10px 0; */
		display: flex;
		color: #FFFFFF;
		font-weight: normal;
	}
	.equipmentbox_table ul>li{
		width: 25%;
		display: flex;
		padding: 1vh 0;
		font-size: .5vw;
		justify-content: center;
		align-items: center;
		
	}
	.equipmentbox_table ul>li:last-of-type{
		background: url(../../../assets/img/equipmentbgok.png) no-repeat;
		background-position: center center; 
		background-size: auto 70%;
		cursor: pointer;
	}
	
	
</style>
